import { defaultTheme } from '@amzn/storm-ui';

const sentimentScaleOptionLabelEmojiTheme = {
  background: defaultTheme.palette.gray[0],
  backgroundChecked: {
    veryDissatisfied: defaultTheme.palette.red[200],
    dissatisfied: defaultTheme.palette.data.orange[300],
    neitherSatisfiedNorDissatisfied: defaultTheme.palette.gold[200],
    satisfied: defaultTheme.palette.data.green[300],
    verySatisfied: defaultTheme.palette.green[200]
  },
  path: defaultTheme.palette.gray[700],
  pathDisabled: defaultTheme.palette.gray[700],
  // @TODO:check with designer
  pathHovered: defaultTheme.palette.gray[900],
  pathChecked: defaultTheme.palette.gray[900]
};

export { sentimentScaleOptionLabelEmojiTheme as s };
//# sourceMappingURL=sentimentScaleOptionLabelEmojiTheme-C7XWHqID.js.map
